<template>
  <ITabs
    :tabs="tabsList"
    @check-tab="checkTab"
  />
  <IDateSwiper v-model="filterModel.dateRange" />
</template>

<script setup>
import { ref, watch } from 'vue';
import ITabs from '../../components/ITabs/ITabs.vue';
import IDateSwiper from '../../components/IDateSwiper/IDateSwiper.vue';
import useSiteStore, { blockingTypeEnum } from '../../store/modules/site.js';

const siteStore = useSiteStore();

const filterModel = ref({
  dateRange: [],
  selectTypes: siteStore.getSelectTypes.items,
});

const tabsList = ref([
  {
    name: 'Спорт',
    type: blockingTypeEnum.MATCH,
    checked: true,
  },
  {
    name: 'Шоу',
    type: blockingTypeEnum.SHOW,
    checked: true,
  },
  {
    name: 'Концерты',
    type: blockingTypeEnum.PERFORMANCE,
    checked: true,
  },
  {
    name: 'Абонементы',
    type: blockingTypeEnum.SUBSCRIPTION,
    checked: true,
  },
]);

function checkTab(index) {
  const tab = tabsList.value[index];
  const { type } = tab;

  tab.checked = !tab.checked;

  filterModel.value.selectTypes = tab.checked
    ? [...filterModel.value.selectTypes, type]
    : filterModel.value.selectTypes.filter((t) => t !== type);

  siteStore.setSelectTypes(filterModel.value.selectTypes);
}

function getDateRangeParam() {
  const sortedDates = filterModel.value.dateRange.sort((a, b) => a.date.unix() - b.date.unix());
  const [firstDate, secondDate] = sortedDates;
  if (!firstDate) return [];
  const formatedFirstDate = firstDate.date.format('DD-MM-YYYY');

  const secondFormatedDate = secondDate
    ? secondDate.date.format('DD-MM-YYYY')
    : firstDate.date.format('DD-MM-YYYY');

  return `${formatedFirstDate} — ${secondFormatedDate}`;
}

function applyDates() {
  const searchParams = {
    dateRange: getDateRangeParam(),
  };
  siteStore.searchEvents(searchParams);
  siteStore.searchPerformances(searchParams);
  siteStore.searchSubscriptions(searchParams);
  siteStore.searchShows(searchParams);
}

watch(() => filterModel.value.dateRange, () => applyDates());
</script>
